import AnnualReportCard from "./AnnualReportCard";

type Props = {};

function AnnualReports({}: Props) {
  const years = [2021, 2022, 2023, 2024];
  const basePath = "https://cdn.molhamteam.com/assets/annual-reports/MVT-AR-";
  const lastYear = {
    image: basePath + years[years.length - 1] + ".jpg",
    pdf: basePath + years[years.length - 1] + ".pdf",
    year: years[years.length - 1],
  };
  return (
    <div className="centered flex-column mt-3">
      <AnnualReportCard {...lastYear} mWidth={600} />
      <div
        style={{
          //flex wrap
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-around",
          marginTop: "1rem",
          width: "100%",
        }}
      >
        {years
          .slice(0, years.length - 1)
          .reverse()
          .map((y, i) => {
            const image = basePath + y + ".jpg";
            const pdf = basePath + y + ".pdf";
            return (
              <AnnualReportCard key={i} image={image} pdf={pdf} year={y} />
            );
          })}
      </div>
    </div>
  );
}

export default AnnualReports;
